import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { IPI1TaxTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class IPI1Repository extends RepositoryBase<IPI1TaxTable> {
  protected readonly KEY_PATH = 'ipi1';
}
